import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" action: the intent the UI dispatches for the saga to act on. Kept
 * out of the slice's reducers: it triggers a side effect (the PATCH), not a
 * state transition (the saga owns the resulting `save*` transitions).
 */

/** Submit the current draft (dispatched when the admin clicks Save). */
export const submitRequested = createAction('editProfileIdentity/submitRequested');
